interface LoadingSpinnerProps {
  className?: string;
  height?: string;
}

export default function LoadingSpinner({ className = '', height = 'h-8' }: LoadingSpinnerProps) {
  return (
    <div className={`shimmer rounded-card ${height} w-full ${className}`} role="status" aria-label="Loading" />
  );
}
